import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=1af85c3f&scoped=true&"
import script from "./Funds.vue?vue&type=script&lang=js&"
export * from "./Funds.vue?vue&type=script&lang=js&"
import style0 from "./Funds.vue?vue&type=style&index=0&id=1af85c3f&scoped=true&lang=css&"
import style1 from "./Funds.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af85c3f",
  null
  
)

export default component.exports